import generateBasicCardBlock from './generateBasicCardBlock';

const generateLinkCard = (linkId, title, date, imageUrl) => {
	const template = generateBasicCardBlock(title, date, imageUrl);

	template.setAttribute('href', `media/${linkId}`);

	return template;
};

export default generateLinkCard;



// WEBPACK FOOTER //
// ./src/js/about/generateLinkCard.js